import React, { useMemo, useEffect, useState, useRef } from 'react';
import { mergeStyleSets } from '@fluentui/react';

import { tryParseSubstitution, hasSubstitutions } from 'shared/utils/querySubstitution';

export { tryParseSubstitution, hasSubstitutions };


export const classNames = mergeStyleSets({
  withTargetPicker: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'stretch',
    alignItems: 'center',
  },
});


export function useConversionWithValidation(props, converters) {
  const { value: text } = props;

  useEffect(() => checkValue(), []);
  useEffect(() => checkValue(), [text]);

  const res = useConversion(props, converters);
  const { parse } = res;

  function checkValue() {
    const { error } = parse(text);
    error && onChange({ value: text, error });
  }

  return res;
}

export function useConversion({ value: initialValue, substitutionProps = {}, onChange }, converters) {
  const { parse, format, getDefault } = converters;
  const tryParse = getSubstitutionParser(substitutionProps, getDefault);
  
  function parseValue(text) {
    const v = typeof(text) === 'string' ? tryParse(text) : {};
    return v.substitution ? v : parse(text, tryParse);
  }

  function handleChange(updatedValue) {
    const fmt = format(updatedValue, tryParse);
    onChange(fmt);
  }


  return { ...parseValue(initialValue), onChange: handleChange, parse: parseValue };
}

export function getSubstitutionParser(substitutionProps, getDefault) {
  const { 
    allowSubstitutions = true,
    validate = noopValidate,
  } = substitutionProps;

  function tryParse(text) {
    if (allowSubstitutions) {
      const { hasSubstitutions, substitutions } = tryParseSubstitution(text);
      if (hasSubstitutions) {
        return { substitution: text, value: getDefault(), error: validate(substitutions) };
      }
    }

    return {};
  }

  return tryParse;
}

export function useSubstitutionPicker({ substitutionProps = {}, disabled, onChange }) {
  function handleChange(substitution) {
    const { validate = noopValidate } = substitutionProps;
    const { substitutions } = tryParseSubstitution(substitution);
    const error = validate(substitutions);
    onChange({ value: substitution, substitution, error });
  }

  return { ...substitutionProps, disabled, onChange: handleChange };
}


function noopValidate(substitutions) {
  return '';
}


export function useTraceUpdate(props, source = '') {
  const prev = useRef(props);
  useEffect(() => {
    const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
      if (prev.current[k] !== v) {
        ps[k] = [prev.current[k], v];
      }
      return ps;
    }, {});
    if (Object.keys(changedProps).length > 0) {
      console.log(`Changed props of '${source}':`, changedProps);
    }
    prev.current = props;
  });
}
